<template>
    <va-create-layout>
        <Order-form :title="title" :item="item"></Order-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
